import React, { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { IoMdArrowRoundBack } from "react-icons/io";
import { useDispatch, useSelector } from 'react-redux';
import { GetSmsGatewayView } from '../Features/SmsGatewaysdata';
import { RootState, AppDispatch } from '../Appstore/store';
import { formatDate } from '../helper';
import { setIsLoading } from '../Features/loadingSlice';

interface PhoneNumber {
    gateway_number: string;
}

interface SmsGatewayRecord {
    id: number;
    name: string;
    slug: string;
    sending_limit: number | null;
    api_key: string;
    public_key: string;
    account_sid: string;
    auth_token: string;
    createdAt: string;
    updatedAt: string;
    phone_numbers: PhoneNumber[];
    gateway: {
        name: string;
    };
}

function Viewrecord() {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const { id }: any = useParams();

    const { error, smsgatewaysdata, loading } = useSelector((state: RootState) => state.smsgateways);
    const record: SmsGatewayRecord | any = smsgatewaysdata.find(gateway => gateway.id === Number(id));

    useEffect(() => {
        if (id) {
            dispatch(setIsLoading(true));
            dispatch(GetSmsGatewayView(id))
                .unwrap()
                .catch(err => {
                    console.error('Error fetching agent monitor:', err);
                })
                .finally(() => {
                    setTimeout(() => dispatch(setIsLoading(false)), 500);
                });
        }
    }, [id, dispatch]);

    if (!record) {
        return <div>No record found</div>;
    }
    const navigatetobackpage = () => {
        navigate(-1);
    };

    return (
        <>
            <div className="wrapper">
                <div className="content-wrapper">
                    <section className="content">
                        <div className="container-fluid">
                            <div className="card mt-4 shadow-sm border rounded">
                                <div className="card-header bg-white p-3 d-flex justify-content-md-between">
                                    <h2 className="w-100 mb-md-0 fs-3">View SMS Gateway</h2>
                                    <Link to={''} className='text-decoration-none'>
                                        <button onClick={navigatetobackpage} className='btn btn-info text-white d-flex align-items-center fw-semibold'>
                                            <IoMdArrowRoundBack /> Back
                                        </button>
                                    </Link>
                                </div>

                                <div className="card-body px-0 py-0">
                                    <div className='table-responsive'>
                                        <table className="table mb-0 table-bordered">
                                            <tbody>
                                                {loading ? (
                                                    <tr>
                                                        <td colSpan={7} height={100}>
                                                            <div className="text-center" >
                                                                <div className="loader"></div>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : error ? (
                                                    <tr>
                                                        <td colSpan={7} height={50}>
                                                            <div className="text-center">
                                                                <p className='mb-0 fs-5 fw-semibold'>No data found</p>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ) : (
                                                    <>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Name</th>
                                                            <td className='p-3'>{record.name}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Slug</th>
                                                            <td className='p-3'>{record.slug}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Gateway Name</th>
                                                            <td className='p-3'>{record.gateway?.name}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Account SID</th>
                                                            <td className='p-3'>{!record.account_sid ? '-' : record.account_sid}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Auth Token</th>
                                                            <td className='p-3'>{!record.auth_token ? '-' : record.auth_token}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Phone Numbers</th>
                                                            <td className='p-3'>
                                                                {record?.phone_numbers && Array.isArray(record.phone_numbers) && record.phone_numbers.length > 0 ? (
                                                                    record.phone_numbers.map((phone: PhoneNumber, index: number) => (
                                                                        <span key={index}>
                                                                            {phone.gateway_number}
                                                                            {index < record.phone_numbers.length - 1 && ', '}
                                                                        </span>
                                                                    ))
                                                                ) : (
                                                                    'No phone numbers available'
                                                                )}
                                                            </td>

                                                        </tr>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Sending Limit</th>
                                                            <td className='p-3'>{record.sending_limit ?? 'No Limit'}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>API Key</th>
                                                            <td className='p-3'>{record.api_key ?? '-'}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Public Key</th>
                                                            <td className='p-3'>{record.public_key ?? '-'}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Created At</th>
                                                            <td className='p-3'>{formatDate(record.createdAt)}</td>
                                                        </tr>
                                                        <tr>
                                                            <th className='p-3 fw-bold' style={{ width: 150 }}>Updated At</th>
                                                            <td className='p-3'>{formatDate(record.updatedAt)}</td>
                                                        </tr>
                                                    </>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                </div>
            </div>
        </>
    );
}

export default Viewrecord;
